import { type FunctionComponent, type PropsWithChildren, useState } from 'react';
import { roadmapPageContext } from './roadmap-page-context';

export const RoadmapContextProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const [showCompletedEvents, setShowCompletedEvents] = useState(false);

    const toggleShowCompletedEvents = (show: boolean) => setShowCompletedEvents(show);

    return (
        <roadmapPageContext.Provider
            value={{
                showCompletedEvents,
                setShowCompletedEvents: toggleShowCompletedEvents,
            }}
        >
            {children}
        </roadmapPageContext.Provider>
    );
};
